import OrgCard from "components/OrgCard"
import ASCM from "images/organizations/ASCM.svg"
import IWLA from "images/organizations/IWLA.svg"
import WERC from "images/organizations/WERC.svg"
import { fmobile, fresponsive, ftablet } from "library/fullyResponsive"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function SocialProof() {
	return (
		<Wrapper>
			<Title>Official member of trusted supply chain organizations</Title>
			<MobileWrapper>
				<OrgCard
					name="Association for Supply Chain Management"
					logo={ASCM}
					url="https://www.ascm.org/"
				/>
				<OrgCard
					name="International Warehouse Logistics Association"
					logo={IWLA}
					url="https://www.iwla.com/"
				/>
				<OrgCard
					name="Warehousing Education and Research Council"
					logo={WERC}
					url="https://werc.org/"
				/>
			</MobileWrapper>
		</Wrapper>
	)
}

const Wrapper = styled.section`
	border-top: 1px solid ${colors.grey1};

	${fresponsive(css`
		display: grid;
		grid-template-columns: 1fr auto auto auto;
		margin: 40px 40px 165px;
		padding: 40px 0 0;
	`)}

	${ftablet(css`
		grid-template-columns: 1fr 1fr 1fr;
		margin: 40px 40px 36px;
		padding: 40px 0 0;
		gap: 30px 20px;
	`)}

  ${fmobile(css`
		display: flex;
		flex-direction: column;
		margin: 30px 0 65px;
		padding: 40px 16px 0;
		gap: 40px;
		align-items: center;
	`)}
`

const Title = styled.h1`
	${fresponsive(css`
		${textStyles.h5};
		width: 392px;
	`)}

	${ftablet(css`
		grid-column: 1 / 4;
		${textStyles.h4};
		width: 460px;
	`)}

  ${fmobile(css`
		${textStyles.h6};
		text-align: center;
		width: 261px;
		margin-bottom: 0;
	`)}
`

const MobileWrapper = styled.div`
	${fresponsive(css`
		display: flex;
		gap: 20px;
	`)}
	${fmobile(css`
		display: flex;
		justify-content: space-between;
		width: 100%;
		gap: unset;
	`)}
`
